import { render } from "./Dashboard.vue?vue&type=template&id=17205642"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__